export const mapboxAccessToken =
  'pk.eyJ1IjoiZWlndGVjaCIsImEiOiJjbHExYWttaGEwNzNwMnFxdDdoenFvNjVnIn0.5lA6mxyF-tXkfoj6hT4kUg'
